// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"38190e3abfb884f0","199":"8b1d2b8d6b16cbe6","222":"e53d6b67fab8c4d6","495":"151cc76fdeb7cbd4","893":"6f5cc6f8dcdc2a7d"}[chunkId] + ".js";
};